export const SAVE_TEAM_CLARIFICATION_REQUESTED = 'SAVE_TEAM_CLARIFICATION_REQUESTED'
export const SAVE_TEAM_CLARIFICATION_SUCCEEDED = 'SAVE_TEAM_CLARIFICATION_SUCCEEDED'
export const SAVE_TEAM_CLARIFICATION_FAILED = 'SAVE_TEAM_CLARIFICATION_FAILED'

export const GET_TEAM_REQUESTED = 'GET_TEAM_REQUESTED'
export const GET_TEAM_SUCCEEDED = 'GET_TEAM_SUCCEEDED'
export const GET_TEAM_FAILED = 'GET_TEAM_FAILED'

export const GET_TEAM_CLARIFICATIONS_REQUESTED = 'GET_TEAM_CLARIFICATIONS_REQUESTED'
export const GET_TEAM_CLARIFICATIONS_SUCCEEDED = 'GET_TEAM_CLARIFICATIONS_SUCCEEDED'
export const GET_TEAM_CLARIFICATIONS_FAILED = 'GET_TEAM_CLARIFICATIONS_FAILED'

export const SAVE_TEAM_MEMBER_REQUESTED = 'SAVE_TEAM_MEMBER_REQUESTED'
export const SAVE_TEAM_MEMBER_SUCCEEDED = 'SAVE_TEAM_MEMBER_SUCCEEDED'
export const SAVE_TEAM_MEMBER_FAILED =    'SAVE_TEAM_MEMBER_FAILED'

export const SAVE_INVITED_TEAM_MEMBER_REQUESTED = 'SAVE_INVITED_TEAM_MEMBER_REQUESTED'
export const SAVE_INVITED_TEAM_MEMBER_SUCCEEDED = 'SAVE_INVITED_TEAM_MEMBER_SUCCEEDED'
export const SAVE_INVITED_TEAM_MEMBER_FAILED =    'SAVE_INVITED_TEAM_MEMBER_FAILED'

export const DELETE_TEAM_MEMBER_REQUESTED = 'DELETE_TEAM_MEMBER_REQUESTED'
export const DELETE_TEAM_MEMBER_SUCCEEDED = 'DELETE_TEAM_MEMBER_SUCCEEDED'
export const DELETE_TEAM_MEMBER_FAILED =    'DELETE_TEAM_MEMBER_FAILED'

export const UPLOAD_TEAM_DOCUMENT_REQUESTED = 'UPLOAD_TEAM_DOCUMENT_REQUESTED'
export const UPLOAD_TEAM_DOCUMENT_SUCCEEDED = 'UPLOAD_TEAM_DOCUMENT_SUCCEEDED'
export const UPLOAD_TEAM_DOCUMENT_FAILED = 'UPLOAD_TEAM_DOCUMENT_FAILED'

export const GET_SELECTED_TEAMS_PAIRINGS_REQUESTED = 'GET_SELECTED_TEAMS_PAIRINGS_REQUESTED'
export const GET_SELECTED_TEAMS_PAIRINGS_SUCCEEDED = 'GET_SELECTED_TEAMS_PAIRINGS_SUCCEEDED'
export const GET_SELECTED_TEAMS_PAIRINGS_FAILED = 'GET_SELECTED_TEAMS_PAIRINGS_FAILED'

export const SAVE_TEAM_ORDER_REQUESTED = 'SAVE_TEAM_ORDER_REQUESTED'
export const SAVE_TEAM_ORDER_SUCCEEDED = 'SAVE_TEAM_ORDER_SUCCEEDED'
export const SAVE_TEAM_ORDER_FAILED = 'SAVE_TEAM_ORDER_FAILED'

export const GET_TEAM_PAYMENT_HISTORY_REQUESTED = 'GET_TEAM_PAYMENT_HISTORY_REQUESTED'
export const GET_TEAM_PAYMENT_HISTORY_SUCCEEDED = 'GET_TEAM_PAYMENT_HISTORY_SUCCEEDED'
export const GET_TEAM_PAYMENT_HISTORY_FAILED = 'GET_TEAM_PAYMENT_HISTORY_FAILED'


export const GENERATE_TEAM_INVOICE_REQUESTED = 'GENERATE_TEAM_INVOICE_REQUESTED'
export const GENERATE_TEAM_INVOICE_SUCCEEDED = 'GENERATE_TEAM_INVOICE_SUCCEEDED'
export const GENERATE_TEAM_INVOICE_FAILED = 'GENERATE_TEAM_INVOICE_FAILED'

export const CREATE_STRIPE_PAYMENT_INTENT_REQUESTED = 'CREATE_STRIPE_PAYMENT_INTENT_REQUESTED'
export const CREATE_STRIPE_PAYMENT_INTENT_SUCCEEDED = 'CREATE_STRIPE_PAYMENT_INTENT_SUCCEEDED'
export const CREATE_STRIPE_PAYMENT_INTENT_FAILED = 'CREATE_STRIPE_PAYMENT_INTENT_FAILED'
export const CREATE_STRIPE_CONFIRMATION_QUOTE_REQUESTED = 'CREATE_STRIPE_CONFIRMATION_QUOTE_REQUESTED'
export const CREATE_STRIPE_CONFIRMATION_QUOTE_SUCCEEDED = 'CREATE_STRIPE_CONFIRMATION_QUOTE_SUCCEEDED'
export const CREATE_STRIPE_CONFIRMATION_QUOTE_FAILED = 'CREATE_STRIPE_CONFIRMATION_QUOTE_FAILED'
export const FINALIZE_STRIPE_PAYMENT_REQUESTED = 'FINALIZE_STRIPE_PAYMENT_REQUESTED'
export const FINALIZE_STRIPE_PAYMENT_SUCCEEDED = 'FINALIZE_STRIPE_PAYMENT_SUCCEEDED'
export const FINALIZE_STRIPE_PAYMENT_FAILED = 'FINALIZE_STRIPE_PAYMENT_FAILED'

export const CREATE_PAYMENT_FEE_QUOTE_REQUESTED = 'CREATE_PAYMENT_FEE_QUOTE_REQUESTED'
export const CREATE_PAYMENT_FEE_QUOTE_SUCCEEDED = 'CREATE_PAYMENT_FEE_QUOTE_SUCCEEDED'
export const CREATE_PAYMENT_FEE_QUOTE_FAILED = 'CREATE_PAYMENT_FEE_QUOTE_FAILED'

export const GET_INVITE_LINK_REQUESTED = 'GET_INVITE_LINK_REQUESTED'
export const GET_INVITE_LINK_SUCCEEDED = 'GET_INVITE_LINK_SUCCEEDED'
export const GET_INVITE_LINK_FAILED = 'GET_INVITE_LINK_FAILED'

export const SEND_INVITE_LINK_REQUESTED = 'SEND_INVITE_LINK_REQUESTED'
export const SEND_INVITE_LINK_SUCCEEDED = 'SEND_INVITE_LINK_SUCCEEDED'
export const SEND_INVITE_LINK_FAILED = 'SEND_INVITE_LINK_FAILED'